import { routes } from "./routes";
import { UserModules } from "../redux/slices/AuthSlice2";

export const getFirstAvailableRoute = (modules: UserModules | null | undefined): string => {
  if (!modules) return routes.dashboard;

  if (modules.map_checkins !== false) return routes.dashboard;
  if (modules.rank_tracker !== false) return routes.manageLocalBusiness;
  if (modules.ctr !== false) return routes.ctrBooster;
  if (modules.map_checkins !== false) return routes.mapCheckingDashboard;
  if (modules.book_call !== false) return routes.scheduleACall;
  if (modules.white_label !== false) return routes.whitelabel;
  if (modules.team !== false) return routes.workspaceMember;
  if (modules.billing !== false) return routes.billing;

  return routes.dashboard; // Fallback
};
